module.exports = __webpack_public_path__ + "static/media/icon_dentweb.1eac978a.svg";